import * as React from "react";
import { useState } from "react";
import argusIcon from "../../svgs/argus-logo.svg";
import defaultLogo from "../../svgs/bank-logo.svg";
import tcbLogo from "../../svgs/bank-logo-tcb.svg";
import { CardGroup } from "react-bootstrap";
import { visibleNavGroups } from "../../config/clientResolver";

import "../../css/pageStyle.css";
import "../../css/homePageStyle.css";
import "../../sass/_homePage.scss";
import Tile from "../sub-components/Tile.tsx";
import Footer from "../sub-components/Footer.tsx";

/* Main Landing page after the Authentication */
const MainLanding = () => {
  // different hovering options for different tiles
  const [homePageHover, setHomePageHover] = useState(false);
  const [rebateWorkflowHover, setRebateWorkflowHover] = useState(false);
  const [portfolioManagementHover, setPortfolioManagementHover] =
    useState(false);
  const [clientPortfolioSetupHover, setClientPortfolioSetupHover] =
    useState(false);
  const [userAdministrationHover, setUserAdministrationHover] = useState(false);
  const logoMap: Record<string, string> = {
    'bank-logo.svg': defaultLogo,
    'bank-logo-tcb.svg': tcbLogo,
  };

  const bankLogoFile = process.env.REACT_APP_BANK_LOGO || 'bank-logo.svg';
  const bankLogoIcon = logoMap[bankLogoFile] ?? defaultLogo;

  // adding elements on hover to the tiles
  const addHomePageElements = () => setHomePageHover(true);
  const addPortfolioManagementElements = () =>
    setPortfolioManagementHover(true);
  const addRebateWorkflowElements = () => setRebateWorkflowHover(true);
  const addClientPortfolioElements = () => setClientPortfolioSetupHover(true);
  const addUserAdminElements = () => setUserAdministrationHover(true);

  // removing elements after mouse leave to the tiles
  const removeHomePageElements = () => setHomePageHover(false);
  const removePortfolioManagementElements = () =>
    setPortfolioManagementHover(false);
  const removeRebateWorkflowElements = () => setRebateWorkflowHover(false);
  const removeClientPortfolioElements = () =>
    setClientPortfolioSetupHover(false);
  const removeUserAdminElements = () => setUserAdministrationHover(false);

  // dynamically adding different states to the tiles component
  const tilesConfigData = {
    homePage: {
      hoverState: homePageHover,
      addElements: addHomePageElements,
      removeElements: removeHomePageElements,
    },
    portfolioManagement: {
      hoverState: portfolioManagementHover,
      addElements: addPortfolioManagementElements,
      removeElements: removePortfolioManagementElements,
    },
    rebateWorkflow: {
      hoverState: rebateWorkflowHover,
      addElements: addRebateWorkflowElements,
      removeElements: removeRebateWorkflowElements,
    },
    clientPortfolioSetup: {
      hoverState: clientPortfolioSetupHover,
      addElements: addClientPortfolioElements,
      removeElements: removeClientPortfolioElements,
    },
    userAdministration: {
      hoverState: userAdministrationHover,
      addElements: addUserAdminElements,
      removeElements: removeUserAdminElements,
    },
  };

  return (
    <div className="page">
      <div className="pt-4 header-home-page">
        <img src={argusIcon} className="company-name" />
        <div className="vertical"></div>
        <img src={bankLogoIcon} className="bank-name" />
      </div>
      <div className="mt-6 ps-2 pe-2 ms-5 cc-card">
        <h1 className="pt-2 cc-card-h1">REBATE MANAGEMENT & ANALYTICAL SOLUTION</h1>
      </div>
      <div className="ms-6 card-div">
        <CardGroup className="row row-cols-sm-1 row-cols-mb-3 row-cols-ls-5 row-cols-xl-5 row-cols-xxl-6 row-cols-fluid-6 gx-0 gy-2 mt-2 ms-5">
          {visibleNavGroups
            .map((linkDetail, index) => (
            <Tile
              cardId={linkDetail.id}
              cardName={linkDetail.name}
              cardText=''
              cardLinks={linkDetail.links}
              cardIcon={linkDetail.icon}
              mouseEnter={tilesConfigData[linkDetail.id].addElements}
              mouseLeave={tilesConfigData[linkDetail.id].removeElements}
              displayOnHover={tilesConfigData[linkDetail.id].hoverState}
              key={linkDetail.id + index}
            ></Tile>
          ))}
        </CardGroup>
      </div>
      <Footer cssClassName="ms-3"/>
    </div>
  );
};

export default MainLanding;
